import styled from "styled-components";
import { Link, useNavigate } from 'react-router-dom';
import { ApiService } from '../api';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { userNameText } from '../atom/UserAtom';
import React, {useState, useEffect, useRef} from 'react';

const Header = () => {
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);
    const [userName, setUserName] = useRecoilState(userNameText);

    const navigate = useNavigate();

    const apiService = new ApiService();

    const getUserName: any = async () => {
        try {
            if (!accessToken) return;
            const userInfor: any = await apiService.getUserName(accessToken);
            setUserName(userInfor.name);
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    }

    useEffect(() => {
        getUserName();
    }, [accessToken]);

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expire');
        localStorage.removeItem('updateTime');
        navigate('/login');
    };

    return (
        <>
            <Wrap className="flex aic jce">
                <div className="user-infor-box flex">
                    <h3>{userName}</h3>
                    <button className="logout-btn" onClick={handleLogout}>로그아웃</button>
                </div>
            </Wrap>
        </>
    );
}

export default Header;

const Wrap = styled.header`
    width: 100%;
    height: 80px;
    background-color: #fafafa;
    padding: 0 28px;
    box-sizing: border-box;
    border-bottom: 1px solid ${props => props.theme.borderColor};

    .user-infor-box {
        gap: 16px;

        h3 {
            font-size: 16px;
            color: ${props => props.theme.mainColor1};
            font-weight: 500;
        }
        
        .logout-btn {
            font-size: 14px;
            color: #999;
        }
    }

    .right-box-area .header-box-area .name {
        line-height: 80px;
        
        margin-right: 16px;
    }
    .right-box-area .header-box-area .log-out-btn {
        line-height: 80px;
        font-size: 16px;
        color: #555;
    }
`